export enum CategoryTagMapping {
  'technology' = 'technologyTag',
  'coverage_area' = 'coverageAreaTag',
  'application' = 'applicationTag',
  'purpose' = 'purposeTag',
  'theme' = 'themeTag'
}

export function getCategoryTagField(type: string): string {
  return CategoryTagMapping[type as keyof typeof CategoryTagMapping] || 'technologyTag';
}